inputs-search-submit
  button(class="btn {opts.klass} btn-block" if="{!opts.disabled}")
    | { opts.label }
    span(class="sk-three-bounce {now-loading: isLoading}")
      span.one.sk-child
      span.two.sk-child.sk-bounce1
      span.three.sk-child.sk-bounce2
  button(class="btn {opts.klass} btn-block" if="{ opts.disabled}" disabled="disabled") { opts.label }
  script(type="typescript").
    this.mixin('inputs.submit');
  style(scoped).
    :scope {
      display: block;
    }
    .sk-three-bounce {
      padding-left:10px;
      display: none;
      margin: 0;
      width: auto;
    }
    .sk-three-bounce .sk-child{
      background-color: #fff;
    }
    .sk-three-bounce .sk-child {
      width: 10px;
      height: 10px;
    }
    .now-loading.sk-three-bounce {
      display: inline-block;
    }
